<template>
    <div class="amex-geo-banner" v-if="isOpen">
    <div class="amex-geo-banner__background"></div>
        <button class="amex-geo-banner__submit" @click="close()"></button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isOpen: false
        }
    },
    mounted() {
        this.$bus.$on('openAmexGeoBanner', this.open)
    },
    beforeDestroy() {
        this.$bus.$off('openAmexGeoBanner', this.open)
    },
    methods: {
        open() {
            this.isOpen = true
        },
        close() {
            this.isOpen = false
        },
    },
}
</script>

<style lang="scss" scoped>
.amex-geo-banner {
    @include fixed-modal(9999);
    @include flex(column, flex-end, center);
    padding: 0 40px 60px 40px;
  /* Alternative with more color stops for smoother transition */
    background: linear-gradient(to bottom, #182744 12%, #264778 31%, #1a2c4b 50%, #131d33 67%, #10182a 100%);
    font-family: 'BPG Algeti', sans-serif;
    
    &__background {
        width: 100%;
        position: absolute;
        inset: 0;
        z-index: -1;
        height: 100%;

        background-image: url('/img/amex_geo_banner.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position-x: center;
    }

    &__submit {
       position: absolute;
       bottom: 0;
       left: 0;
       right: 0;
       opacity: 0;
       z-index: 1;
       height: 17%;
    }

    &__texts {
        @include flex(column, flex-start, flex-start);
        margin-bottom: 38px;
    }

    &__text {
        @include font(22.59, 100%, 400);
        color: $white;

        &--small {
            @include font(18, 100%, 400);
        }

        &--lead {
            color: rgba(189, 233, 255, 1);
        }
    }

    &__divider{
        width: 100%;

        &--first {
            height: 30px;
        }

        &--second {
            height: 36px;
        }
    }

    &__icon {
        @include flex(row, flex-start, flex-start);
        width: 100%;
        margin-bottom: 28px;
    }
}
</style>